// extracted by mini-css-extract-plugin
export default {"summary-container":"UserReportsSummary_summary-container__CZGnR","summary-ctas":"UserReportsSummary_summary-ctas__F8g56"};